import {
  Button,
  ButtonProps,
  Drawer as ChakraDrawer,
  DrawerBodyProps,
  DrawerContentProps,
  DrawerFooterProps,
  DrawerHeaderProps,
  DrawerRootProps,
} from '@chakra-ui/react'
import {useState} from 'react'
import {LuMaximize2, LuMinimize2, LuX} from 'react-icons/lu'

export interface DrawerProps extends Omit<DrawerRootProps, 'id'> {
  id: string
  contentProps?: DrawerContentProps & {'data-e2e'?: string}
  expandable?: boolean
  blockInverseIndex?: boolean
  hideCloseTrigger?: boolean
}

export function Drawer({children, contentProps, hideCloseTrigger, ...props}: DrawerProps) {
  const [isExpanded, setIsExpanded] = useState(false)
  return (
    <ChakraDrawer.Root {...props}>
      <ChakraDrawer.Backdrop />
      <ChakraDrawer.Positioner>
        <ChakraDrawer.Content
          position="relative"
          display="flex"
          flexDirection="column"
          width="100%"
          maxWidth={isExpanded ? '100%' : props.size ? undefined : 'xl'}
          minHeight="0"
          {...contentProps}
        >
          {props.expandable && (
            <Button
              size="xs"
              variant="ghost"
              position="absolute"
              right="12"
              top="4"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {isExpanded ? <LuMinimize2 /> : <LuMaximize2 />}
            </Button>
          )}

          {!hideCloseTrigger && <DrawerCloseTrigger position="absolute" right="4" top="4" />}

          {children}
        </ChakraDrawer.Content>
      </ChakraDrawer.Positioner>
    </ChakraDrawer.Root>
  )
}

export function DrawerHeader({children, ...props}: DrawerHeaderProps) {
  return (
    <ChakraDrawer.Header borderBottomWidth="1px" borderBottomColor="border" {...props}>
      {children}
    </ChakraDrawer.Header>
  )
}

export function DrawerBody({children, ...props}: DrawerBodyProps) {
  return (
    <ChakraDrawer.Body height="100%" flex="1 1 0%" spaceY="5" display="flex" flexDirection="column" {...props}>
      {children}
    </ChakraDrawer.Body>
  )
}

export function DrawerFooter({children, ...props}: DrawerFooterProps) {
  return (
    <ChakraDrawer.Footer borderTopWidth="1px" borderBottomColor="border" py="4" {...props}>
      {children}
    </ChakraDrawer.Footer>
  )
}

export function DrawerCloseTrigger({children, ...props}: ButtonProps) {
  return (
    <ChakraDrawer.CloseTrigger asChild>
      <Button size="xs" variant="ghost" {...props}>
        {!children && <LuX />}
        {children}
      </Button>
    </ChakraDrawer.CloseTrigger>
  )
}
